"use client";

import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Link from "next/link";
import React, { useCallback, useEffect, useState } from "react";
import { useParams, usePathname } from "next/navigation";

import { batchItems } from "@/data/MainSidebarItems";
import styles from "./styles.module.scss";
import Components from "@/components";

function BatchSidebar(props) {
  const [sideItems, setSideItems] = useState([]);
  const pathname = usePathname();
  const { batchId } = useParams();

  const currentPath = () => {
    let path = pathname.split("/");
    let section = path[path?.length - 1];
    return section?.length > 14 ? "" : section;
  };

  const filterSidebarItems = useCallback(
    (batchItems, entities) => {
      if (!entities) {
        return batchItems;
      }

      let res = batchItems.filter((item) => {
        return (
          item.title === "Home" ||
          item.title === "" ||
          // entities.includes("Resources") ||
          entities.includes(item.title)
        );
      });

      setSideItems(res);
    },
    [props.entities]
  );

  useEffect(() => {
    filterSidebarItems(batchItems, props.entities);
  }, [filterSidebarItems]);

  const sideBarContent = (
    <Box className={styles["container"]}>
      <List className={styles["top-list"]}>
        <List>
          {sideItems.map((item, i) => (
            <ListItem
              key={i}
              id={item.id}
              component={Link}
              href={`/batches/${batchId}/${item.path}`}
              className={` ${styles["list-item"]} ${
                currentPath() === item.path ? styles.active : styles.inactive
              }`}
            >
              <ListItemIcon className={styles["item-icon"]}>
                <div className={item.type === "new" ? styles["ms-ripple"] : ""}>
                  <span>{item.icon}</span>
                </div>
                {!props.onOpen ? (
                  <div className={styles["item-text"]}>{item.subtitle}</div>
                ) : null}
              </ListItemIcon>
              {props.onOpen ? <ListItemText>{item.title}</ListItemText> : null}
            </ListItem>
          ))}
          <ListItem
            id={`Compiler-key`}
            target={"_blank"}
            href={"https://compiler.cipherschools.com"}
            component={Link}
            className={` ${styles["list-item"]}`}
          >
            <ListItemIcon className={styles["item-icon"]}>
              <div className={styles["ms-ripple"]}>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 256 256"
                  >
                    <path
                      fill="var(--yellow)"
                      d="M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16M92.8 145.6a8 8 0 1 1-9.6 12.8l-32-24a8 8 0 0 1 0-12.8l32-24a8 8 0 0 1 9.6 12.8L69.33 128Zm58.89-71.4l-32 112a8 8 0 1 1-15.38-4.4l32-112a8 8 0 0 1 15.38 4.4m53.11 60.2l-32 24a8 8 0 0 1-9.6-12.8l23.47-17.6l-23.47-17.6a8 8 0 1 1 9.6-12.8l32 24a8 8 0 0 1 0 12.8"
                    />
                  </svg>
                </span>
              </div>
              {!props.onOpen ? (
                <div className={styles["item-text"]}>{"Compiler"}</div>
              ) : null}
            </ListItemIcon>
            {props.onOpen ? (
              <ListItemText>{"Code Compiler"}</ListItemText>
            ) : null}
          </ListItem>
        </List>
      </List>
      <ListItem
        className={styles["list-item"]}
        href={"/courses"}
        component={Link}
      >
        <Components.Tooltip title="Courses" placement="right" arrow>
          <ListItemIcon className={styles["item-icon"]}>
            <svg
              width="27"
              height="27"
              viewBox="0 0 27 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="sidebar-icon"
            >
              <path
                d="M6.97453 0H1.51029C1.10974 0 0.725588 0.159114 0.442353 0.442349C0.159118 0.725583 0 1.10974 0 1.51029V25.0316C0 25.4321 0.159118 25.8163 0.442353 26.0995C0.725588 26.3828 1.10974 26.5419 1.51029 26.5419H6.97453C7.37508 26.5419 7.75923 26.3828 8.04247 26.0995C8.3257 25.8163 8.48482 25.4321 8.48482 25.0316V1.50425C8.48322 1.10474 8.3234 0.72214 8.04034 0.44021C7.75728 0.158281 7.37404 -3.19604e-06 6.97453 0ZM7.00474 22.156C6.94997 22.2117 6.88461 22.2559 6.8125 22.286C6.7404 22.3161 6.66301 22.3314 6.58488 22.3312H1.89995C1.78377 22.3273 1.67117 22.2901 1.57565 22.2238C1.48013 22.1576 1.40575 22.0652 1.36142 21.9577C1.3171 21.8503 1.30472 21.7323 1.32577 21.618C1.34682 21.5037 1.4004 21.3979 1.48008 21.3132C1.53465 21.2573 1.59997 21.2129 1.67212 21.1828C1.74427 21.1526 1.82177 21.1374 1.89995 21.138H6.58488C6.7451 21.138 6.89876 21.2017 7.01205 21.315C7.12535 21.4283 7.18899 21.5819 7.18899 21.7422C7.18762 21.82 7.17059 21.8967 7.13894 21.9678C7.10728 22.0389 7.06164 22.1029 7.00474 22.156ZM7.00474 19.7576C6.94997 19.8134 6.88461 19.8576 6.8125 19.8876C6.7404 19.9177 6.66301 19.9331 6.58488 19.9328H1.89995C1.78377 19.929 1.67117 19.8917 1.57565 19.8255C1.48013 19.7592 1.40575 19.6669 1.36142 19.5594C1.3171 19.4519 1.30472 19.334 1.32577 19.2197C1.34682 19.1053 1.4004 18.9995 1.48008 18.9149C1.53465 18.8589 1.59997 18.8145 1.67212 18.7844C1.74427 18.7543 1.82177 18.7391 1.89995 18.7397H6.58488C6.7451 18.7397 6.89876 18.8034 7.01205 18.9167C7.12535 19.0299 7.18899 19.1836 7.18899 19.3438C7.18762 19.4216 7.17059 19.4984 7.13894 19.5695C7.10728 19.6406 7.06164 19.7046 7.00474 19.7576ZM7.00474 4.28319C6.94997 4.3389 6.88461 4.3831 6.8125 4.41319C6.7404 4.44328 6.66301 4.45864 6.58488 4.45838H1.89995C1.73972 4.45838 1.58607 4.39473 1.47277 4.28144C1.35948 4.16814 1.29583 4.01448 1.29583 3.85426C1.29583 3.69404 1.35948 3.54038 1.47277 3.42708C1.58607 3.31379 1.73972 3.25014 1.89995 3.25014H6.58488C6.70105 3.25398 6.81365 3.29126 6.90917 3.3575C7.00469 3.42374 7.07907 3.51613 7.1234 3.62359C7.16772 3.73104 7.1801 3.849 7.15905 3.96332C7.13801 4.07764 7.08442 4.18346 7.00474 4.26809V4.28319Z"
                fill="currentColor"
              />
              <path
                d="M16.0302 5.41591H10.566C10.1655 5.41591 9.7813 5.57503 9.49807 5.85826C9.21484 6.1415 9.05571 6.52564 9.05571 6.9262V25.0497C9.05571 25.4503 9.21484 25.8344 9.49807 26.1176C9.7813 26.4009 10.1655 26.56 10.566 26.56H16.0302C16.4308 26.56 16.8149 26.4009 17.0982 26.1176C17.3814 25.8344 17.5405 25.4503 17.5405 25.0497V6.9262C17.5405 6.52564 17.3814 6.1415 17.0982 5.85826C16.8149 5.57503 16.4308 5.41591 16.0302 5.41591ZM16.0604 22.7631C16.0057 22.8188 15.9403 22.863 15.8682 22.8931C15.7961 22.9232 15.7187 22.9386 15.6406 22.9383H10.9557C10.7954 22.9383 10.6418 22.8747 10.5285 22.7614C10.4152 22.6481 10.3515 22.4944 10.3515 22.3342C10.3515 22.174 10.4152 22.0203 10.5285 21.907C10.6418 21.7937 10.7954 21.7301 10.9557 21.7301H15.6406C15.7568 21.7339 15.8694 21.7712 15.9649 21.8374C16.0604 21.9037 16.1348 21.9961 16.1791 22.1035C16.2234 22.211 16.2358 22.3289 16.2148 22.4433C16.1937 22.5576 16.1401 22.6634 16.0604 22.748V22.7631ZM16.0604 9.12518C16.0057 9.1809 15.9403 9.2251 15.8682 9.25519C15.7961 9.28527 15.7187 9.30064 15.6406 9.30037H10.9557C10.7954 9.30037 10.6418 9.23673 10.5285 9.12343C10.4152 9.01014 10.3515 8.85648 10.3515 8.69626C10.3515 8.53604 10.4152 8.38238 10.5285 8.26909C10.6418 8.1558 10.7954 8.09214 10.9557 8.09214H15.6406C15.7568 8.09598 15.8694 8.13326 15.9649 8.19949C16.0604 8.26573 16.1348 8.35813 16.1791 8.46558C16.2234 8.57304 16.2358 8.691 16.2148 8.80532C16.1937 8.91963 16.1401 9.02546 16.0604 9.11009V9.12518Z"
                fill="currentColor"
              />
              <path
                d="M25.086 0H19.6217C19.2212 0 18.837 0.159114 18.5538 0.442349C18.2705 0.725583 18.1114 1.10974 18.1114 1.51029V25.0316C18.1114 25.4321 18.2705 25.8163 18.5538 26.0995C18.837 26.3828 19.2212 26.5419 19.6217 26.5419H25.086C25.4865 26.5419 25.8707 26.3828 26.1539 26.0995C26.4371 25.8163 26.5963 25.4321 26.5963 25.0316V1.50425C26.5947 1.10474 26.4348 0.72214 26.1518 0.44021C25.8687 0.158281 25.4855 -3.19604e-06 25.086 0ZM25.1162 22.156C25.0614 22.2117 24.996 22.2559 24.9239 22.286C24.8518 22.3161 24.7744 22.3314 24.6963 22.3312H20.0114C19.8952 22.3273 19.7826 22.2901 19.6871 22.2238C19.5916 22.1576 19.5172 22.0652 19.4729 21.9577C19.4285 21.8503 19.4162 21.7323 19.4372 21.618C19.4582 21.5037 19.5118 21.3979 19.5915 21.3132C19.6461 21.2573 19.7114 21.2129 19.7836 21.1828C19.8557 21.1526 19.9332 21.1374 20.0114 21.138H24.6963C24.8565 21.138 25.0102 21.2017 25.1235 21.315C25.2368 21.4283 25.3004 21.5819 25.3004 21.7422C25.299 21.82 25.282 21.8967 25.2504 21.9678C25.2187 22.0389 25.1731 22.1029 25.1162 22.156ZM25.1162 19.7576C25.0614 19.8134 24.996 19.8576 24.9239 19.8876C24.8518 19.9177 24.7744 19.9331 24.6963 19.9328H20.0114C19.8952 19.929 19.7826 19.8917 19.6871 19.8255C19.5916 19.7592 19.5172 19.6669 19.4729 19.5594C19.4285 19.4519 19.4162 19.334 19.4372 19.2197C19.4582 19.1053 19.5118 18.9995 19.5915 18.9149C19.6461 18.8589 19.7114 18.8145 19.7836 18.7844C19.8557 18.7543 19.9332 18.7391 20.0114 18.7397H24.6963C24.8565 18.7397 25.0102 18.8034 25.1235 18.9167C25.2368 19.0299 25.3004 19.1836 25.3004 19.3438C25.299 19.4216 25.282 19.4984 25.2504 19.5695C25.2187 19.6406 25.1731 19.7046 25.1162 19.7576ZM25.1162 4.28319C25.0614 4.3389 24.996 4.3831 24.9239 4.41319C24.8518 4.44328 24.7744 4.45864 24.6963 4.45838H20.0114C19.8512 4.45838 19.6975 4.39473 19.5842 4.28144C19.4709 4.16814 19.4073 4.01448 19.4073 3.85426C19.4073 3.69404 19.4709 3.54038 19.5842 3.42708C19.6975 3.31379 19.8512 3.25014 20.0114 3.25014H24.6963C24.8125 3.25398 24.9251 3.29126 25.0206 3.3575C25.1161 3.42374 25.1905 3.51613 25.2348 3.62359C25.2791 3.73104 25.2915 3.849 25.2705 3.96332C25.2494 4.07764 25.1958 4.18346 25.1162 4.26809V4.28319Z"
                fill="currentColor"
              />
            </svg>
          </ListItemIcon>
        </Components.Tooltip>
        {props.onOpen ? <ListItemText>Courses</ListItemText> : null}
      </ListItem>
    </Box>
  );

  return (
    <article className={styles["main"]}>
      <Drawer
        variant="permanent"
        classes={{
          paper: `${styles[`drawer-${props.onOpen ? "open" : "close"}`]} ${props.className}`,
        }}
        className={styles.drawer}
        open
      >
        {sideBarContent}
      </Drawer>
    </article>
  );
}

export default BatchSidebar;
